import WorkPackageList from "./list";


if (document.body.getAttribute("data-current-path") === "customer/work_packages") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new WorkPackageList();
    }
}